<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader
          class="w-100 d-flex justify-content-between align-items-center"
        >
          کادر آموزشی
        </CCardHeader>
        <CCardBody class="h-100">
          <CTabs variant="pills" :active-tab="1">
            <CTab title="کادر اداری">
              <div class="styledTabled">
                <CDataTable
                  class="w-100 d-flex justify-content-between h-100"
                  :noItemsView="{
                    noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
                  }"
                  :items="computedManagers"
                  :fields="managerField"
                  hover
                  striped
                  border
                  small
                  fixed
                >
                  <!-- <template #profileImageUrl="{ item }">
                    <td>
                       <CButton :disabled="loading"
                        color="success"
                        square
                        size="sm"
                        class="modal-button"
                        @click="managerImageModal = true"
                      >
                        مشاهده
                      </CButton>
                        </td>
                  </template> -->

                  <template #detail="{ item }">
                    <td>
                      <CButton
                        :disabled="loading"
                        color="success"
                        square
                        size="sm"
                        class="modal-button"
                        @click="onManagerViewModal(item)"
                      >
                        مشاهده
                      </CButton>
                    </td>
                  </template>
                </CDataTable>
                <ViewManagerModal
                  v-model="managerViewModal"
                  :user="selectedItem"
                  @get-manager="getManager"
                />
              </div>
            </CTab>
            <CTab title="آموزگاران">
              <div class="styledTabled">
                <CDataTable
                  class="w-100 d-flex justify-content-between h-100"
                  :noItemsView="{
                    noItems: 'در حال حاضر محتوایی در این قسمت وجود ندارد',
                  }"
                  :items="computedTeachers"
                  :fields="teacherField"
                  hover
                  striped
                  border
                  small
                  fixed
                >
                  <!-- <template #profileImageUrl="{ item }">
                    <td>
                       <CButton :disabled="loading"
                        color="success"
                        square
                        size="sm"
                        class="modal-button"
                        @click="teacherImageModal = true"
                      >
                        مشاهده
                      </CButton>
                       </td>
                  </template> -->

                  <template #detail="{ item }">
                    <td>
                      <CButton
                        :disabled="loading"
                        color="success"
                        square
                        size="sm"
                        class="modal-button"
                        @click="onTeacherViewModal(item)"
                      >
                        مشاهده
                      </CButton>
                    </td>
                  </template>
                </CDataTable>
                <ViewTeacherModal
                  v-model="teacherViewModal"
                  :user="selectedItem"
                  @get-teacher="getTeacher"
                />
              </div>
            </CTab>
          </CTabs>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "@/plugins/axios";
import ViewManagerModal from "@/components/Modals/User/ViewManagerModal.vue";
import ViewTeacherModal from "@/components/Modals/User/ViewTeacherModal.vue";

export default {
  components: { ViewManagerModal, ViewTeacherModal },
  name: "ManageStaff",
  data() {
    return {
      managerField: [
        { key: "name", label: "نام" },
        { key: "lastname", label: "نام خانوادگی" },
        { key: "nationalId", label: "کد ملی" },
        { key: "mobile", label: "شماره تماس" },
        { key: "detail", label: "مشاهده" },
      ],
      teacherField: [
        { key: "name", label: "نام" },
        { key: "lastname", label: "نام خانوادگی" },
        { key: "nationalId", label: "کد ملی" },
        { key: "mobile", label: "شماره تماس" },
        { key: "detail", label: "مشاهده" },
      ],
      managers: [],
      teachers: [],
      managerImageModal: false,
      managerDetailModal: false,
      teacherImageModal: false,
      teacherDetailModal: false,
      managerViewModal: false,
      teacherViewModal: false,
      selectedItem: {},
    };
  },
  computed: {
    computedTeachers() {
      return this.teachers.map((item) => {
        return {
          ...item,
          name: `${item.name}`,
          lastname: `${item.lastname}`,
          nationalId: `${item.nationalId}`,
          mobile: `${item.mobile}`,
          detail: "",
        };
      });
    },
    computedManagers() {
      return this.managers.map((item) => {
        return {
          ...item,
          name: `${item.name}`,
          lastname: `${item.lastname}`,
          nationalId: `${item.nationalId}`,
          mobile: `${item.mobile}`,

          detail: "",
        };
      });
    },
  },
  mounted() {
    this.getManager();
    this.getTeacher();
  },
  methods: {
    async getManager() {
      try {
        this.loading = true;
        const { data } = await axios.get(`/manager`);
        this.managers = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async getTeacher() {
      try {
        this.loading = true;
        const { data } = await axios.get(`/teacher`);
        this.teachers = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    onManagerViewModal(item) {
      this.selectedItem = item;
      this.managerViewModal = true;
    },
    onTeacherViewModal(item) {
      this.selectedItem = item;
      this.teacherViewModal = true;
    },
  },
};
</script>

<style scoped>
.styledTabled {
  padding-top: 24px;
}
</style>
